var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu',{staticClass:"menu"},[_c('li',[_c('button',{on:{"click":_vm.back}},[_c('span',{staticClass:"icon icon-arrow-up"}),_c('span',[_vm._v("Options")])])]),_vm._l((_vm.speeds),function(speed){return _c('li',{key:speed.value},[_c('button',{on:{"click":function($event){return _vm.playbackSpeed(speed.value)}}},[_vm._v(_vm._s(speed.label))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }